export default __webpack_public_path__ + "roboto-v27-latin-regular.4b46d5.woff2";